/** 後端登入成功回傳。 */
export interface LoginResponseInterface {
  token: string
}

/** 後端 admin profile（GET /admin/account/profile）。 */
export interface AdminProfileInterface {
  id: string
  email: string
  name: string | null
  avatar: string | null
  roles: string[] | null
}

/** 登入參數。 */
export interface LoginPayloadInterface {
  email: string
  password: string
  keepLogin: boolean
}

/** token TTL（秒）：對齊後端 TTL_ADMIN / TTL_ADMIN_KEEP_LOGIN。 */
export const TOKEN_MAX_AGE = {
  default: 60 * 60, // 1 小時
  keepLogin: 60 * 60 * 24 * 180, // 半年
} as const

export const TOKEN_COOKIE = 'admin_token'
export const FINGERPRINT_COOKIE = 'admin_fingerprint'

/**
 * 把後端登入失敗 reason 轉成繁中訊息。
 * reason 來自 Modules\Base\Constants\LoginConstants。
 */
export function loginFailMessage(reason?: string): string {
  // reason 值對齊後端 LoginConstants（小寫）：
  // wrong_email_or_password / locked / too_frequent
  switch (reason) {
    case 'wrong_email_or_password':
      return '帳號或密碼錯誤'
    case 'locked':
      return '帳號已被鎖定，請聯絡管理員'
    case 'too_frequent':
      return '嘗試過於頻繁，請稍後再試'
    default:
      return '登入失敗，請稍後再試'
  }
}
